import { BackofficeWrapper } from '../../pages/backoffice/_index.jsx';
import { BackofficeUserAccount } from '../../pages/backoffice/account.jsx';
import {
  CampaignsCreate,
  CampaignsEdit,
  CampaignsList,
  CampaignsShow,
} from '../../pages/backoffice/campaigns/_index.js';
import { CouponsList } from '../../pages/backoffice/coupons/_index.js';
import {
  CustomersPendingConsentEdit,
  CustomersPendingConsentList,
  CustomersPendingConsentShow,
} from '../../pages/backoffice/customers-pending-consent/_index.js';
import {
  CustomersCreate,
  CustomersEdit,
  CustomersList,
  CustomersShow,
} from '../../pages/backoffice/customers/_index.js';
import { Dashboard } from '../../pages/backoffice/dashboard.jsx';
import { HelpCenter } from '../../pages/backoffice/help-center.jsx';
import {
  InvoicesCreate,
  InvoicesEdit,
  InvoicesList,
  InvoicesShow,
} from '../../pages/backoffice/invoices/_index.js';

import { backofficeRoutesAdmin } from './admin.js';

export const backofficeRoutes = {
  path: '/backoffice',
  element: <BackofficeWrapper />,
  children: [
    {
      index: true,
      element: <Dashboard />,
    },
    {
      path: 'help-center',
      element: <HelpCenter />,
    },
    {
      path: 'account',
      element: <BackofficeUserAccount />,
    },
    {
      path: 'campaigns',
      children: [
        { index: true, element: <CampaignsList /> },
        { path: 'create', element: <CampaignsCreate /> },
        { path: ':campaignId', element: <CampaignsShow /> },
        { path: 'edit/:campaignId', element: <CampaignsEdit /> },
      ],
    },
    {
      path: 'coupons',
      children: [{ index: true, element: <CouponsList /> }],
    },
    {
      path: 'invoices',
      children: [
        { index: true, element: <InvoicesList /> },
        { path: 'create', element: <InvoicesCreate /> },
        { path: ':invoiceId', element: <InvoicesShow /> },
        { path: ':invoiceId/edit', element: <InvoicesEdit /> },
      ],
    },
    {
      path: 'customers',
      children: [
        { index: true, element: <CustomersList /> },
        { path: 'create', element: <CustomersCreate /> },
        { path: ':customerId', element: <CustomersShow /> },
        { path: ':customerId/edit', element: <CustomersEdit /> },
        {
          path: 'pending-consent',
          children: [
            { index: true, element: <CustomersPendingConsentList /> },
            {
              path: ':pendingConsentId',
              element: <CustomersPendingConsentShow />,
            },
            {
              path: ':pendingConsentId/edit',
              element: <CustomersPendingConsentEdit />,
            },
          ],
        },
      ],
    },

    // ADMIN ROUTES
    backofficeRoutesAdmin,
  ],
};
